export function getBulkDiscountsForVariantOption(bulkDiscounts = [], variantOptionId) {
  if (!bulkDiscounts || !bulkDiscounts.length) return [];

  return bulkDiscounts.filter(discount => {
    return (
      discount.quantityCondition === 'variantOptionQuantity' &&
      discount.variantOptions.includes(variantOptionId)
    );
  });
}
